import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=5fb4725a"
import script from "./Scrollbar.vue?vue&type=script&lang=js"
export * from "./Scrollbar.vue?vue&type=script&lang=js"
import style0 from "./Scrollbar.vue?vue&type=style&index=0&id=5fb4725a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports